export const ACCOUNTS_GET = 'ACCOUNTS_GET';
export const ACCOUNTSDETAIL_GET = 'ACCOUNTSDETAIL_GET';